<template xmlns:SubmissionTable="http://www.w3.org/1999/html">
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div id="content">
          <section class="page-section">
            <div class="container">
              <div class="row">
                <div class="col-12 ">
                  <h2 class="text-black">
                    Your Submissions
                  </h2>
                  <hr class="divider dark divider-full-width" />
                </div>
              </div>
              <div v-if="ismounted" class="row d-block border">
                <b-tabs content-class="mt-3" class="bg-white border" justified>

                  <b-tab title="Panoptic Segmentation">
                    <SubmissionTable
                      v-if="challenges['panSeg']"
                      :submissions="challenges['panSeg']"
                      :remove-from-leaderboard="removeFromLeaderboard"
                      :submit-to-leaderboard="submitToLeaderboard"
                      :isSemantic="false"
                      :isUncertain="false"
                      :isDetection="false"
                      :isPanoptic="true"
                    ></SubmissionTable>
                    <div
                      v-else
                      style="width:100%"
                      class="d-flex justify-content-center"
                    >
                      <h4 class="align-middle">No Submission found</h4>
                    </div>
                  </b-tab>

                  <b-tab title="Uncertainty-Aware Panoptic Segmentation">
                    <SubmissionTable
                      v-if="challenges['panSegUncertain']"
                      :submissions="challenges['panSegUncertain']"
                      :remove-from-leaderboard="removeFromLeaderboard"
                      :submit-to-leaderboard="submitToLeaderboard"
                      :isSemantic="false"
                      :isUncertain="true"
                      :isDetection="false"
                      :isPanoptic="false"
                    ></SubmissionTable>
                    <div
                      v-else
                      style="width:100%"
                      class="d-flex justify-content-center"
                    >
                      <h4 class="align-middle">No Submission found</h4>
                    </div>
                  </b-tab>

                  <b-tab title="Semantic Segmentation">
                    <SubmissionTable
                      v-if="challenges['semSeg']"
                      :submissions="challenges['semSeg']"
                      :remove-from-leaderboard="removeFromLeaderboard"
                      :submit-to-leaderboard="submitToLeaderboard"
                      :isSemantic="true"
                      :isUncertain="false"
                      :isDetection="false"
                      :isPanoptic="false"
                    ></SubmissionTable>
                    <div
                      v-else
                      style="width:100%"
                      class="d-flex justify-content-center"
                    >
                      <h4 class="align-middle">No Submission found</h4>
                    </div>
                  </b-tab>

                  <b-tab title="Object Detection">
                    <SubmissionTable
                      v-if="challenges['objDet']"
                      :submissions="challenges['objDet']"
                      :remove-from-leaderboard="removeFromLeaderboard"
                      :submit-to-leaderboard="submitToLeaderboard"
                      :isSemantic="false"
                      :isUncertain="false"
                      :isDetection="true"
                      :isPanoptic="false"
                    ></SubmissionTable>
                    <div
                      v-else
                      style="width:100%"
                      class="d-flex justify-content-center"
                    >
                      <h4 class="align-middle">No Submission found</h4>
                    </div>
                  </b-tab>

                </b-tabs>
              </div>
              
              <h4 v-else> Please wait loading...<div class="ml-3 mb-1 spinner-border spinner-border-sm text-primary"></div></h4>
            </div>
          </section>
        </div>
      </main>
    </div>
  </div>
</template>

<style lang="scss">
@import "../style/_variables.scss";
@import "../style/mixins.scss";
</style>
<script>
import { mapActions } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";
import moment from "moment";
import SubmissionTable from "@/views/SubmissionTable";
import { groupBy } from "@/helpers/utils";

export default {
  components: { SubmissionTable, NavigationMain },

  data() {
    return {
      ismounted: false,
      search: "",
      headers: [
        { text: "Created At", value: "created_at" },
        { text: "Name", value: "method_name" },
        {
          text: "IoU",
          align: "start",
          filterable: true,
          value: "results.UPQ.UPQ"
        },
        { text: "Results", value: "evaluated" },
        { text: "", value: "controls", sortable: false }
      ],
      challenges: {}
    };
  },
  methods: {
    ...mapActions("api", [
      "getSubmissions",
      "handleRequestError",
      "changeSubmissionState"
    ]),
    submissionMapper(submission) {
      // eslint-disable-next-line
      submission.created_at = moment(submission.created_at).format(
        "YYYY/MM/DD HH:mm"
      );
      return submission;
    },
    groupBy,
    loadSubmissions() {
      this.getSubmissions()
        .then(data => {
          const items = data.submissions.map(this.submissionMapper);
          const challenges = this.groupBy(items, "challenge");
          this.challenges = {};
          for (const key of Object.keys(challenges)) {
            this.challenges[key] = this.groupBy(challenges[key], "task");
          }
          this.ismounted = true;
        })
        .catch(this.handleRequestError);
    },
    submitToLeaderboard(submission) {
      this.changeSubmissionState({ subId: submission._id, visible: true }).then(
        () => (submission.public = true)
      );
      //this.submitToLeaderboard()
    },
    removeFromLeaderboard(submission) {
      this.changeSubmissionState({
        subId: submission._id,
        visible: false
      }).then(() => (submission.public = false));
    },
    getErrorFromMetaInformation(item) {
      const errorMsg = item?.["meta_information"]?.["error"]?.["msg"];
      return errorMsg ? errorMsg : "Internal Error";
    }
  },
  created(){
    this.loadSubmissions();
  }
};
</script>
